export default __webpack_public_path__ + "static/media/castle-1920.a4343355.jpg";